import { round } from './number'

const MAX_VOLTAGE = 3300 // mV
const RESOLUTION = 1024
// resistance at 25 degrees C
const THERMISTOR_NOMINAL = 10000
// temp. for nominal resistance (almost always 25 C)
const TEMPERATURE_NOMINAL = 25
// The beta coefficient of the thermistor (usually 3000-4000)
const BETA_CO_EFFICIENT = 3950
// the value of the 'other' resistor
const SERIES_RESISTOR = 10000
// 0 Celsius in Kelvin
const ZERO_C = 273.15

/**
 * @param mv Milli-Volt
 * @returns [Celsius, Resistance]
 */
export function mvToTemp(mv: number): [number, number] {
    let adc = (mv / MAX_VOLTAGE) * RESOLUTION

    // convert the value to resistance
    let resistance = RESOLUTION / adc - 1
    resistance = SERIES_RESISTOR / resistance

    let steinhart = resistance / THERMISTOR_NOMINAL // (R/Ro)
    steinhart = Math.log(steinhart) // ln(R/Ro)
    steinhart /= BETA_CO_EFFICIENT // 1/B * ln(R/Ro)
    steinhart += 1 / (TEMPERATURE_NOMINAL + ZERO_C) // + (1/To)
    steinhart = 1 / steinhart // Invert
    steinhart -= ZERO_C // convert absolute temp to C

    return [round(steinhart, 1), round(resistance, 1)]
}

/**
 * @param temp Celsius
 * @returns Milli-Volt
 */
export function tempToMv(temp: number): number {
    let steinhart = temp + ZERO_C
    steinhart = 1 / steinhart
    steinhart -= 1 / (TEMPERATURE_NOMINAL + ZERO_C)
    steinhart *= BETA_CO_EFFICIENT
    steinhart = Math.exp(steinhart)

    let resistance = steinhart * THERMISTOR_NOMINAL
    resistance = SERIES_RESISTOR / resistance

    const adc = RESOLUTION / (resistance + 1)
    const mv = (adc / RESOLUTION) * MAX_VOLTAGE

    return Math.round(mv)
}

// @ts-ignore
window.mvToTemp = mvToTemp
// @ts-ignore
window.tempToMv = tempToMv
